import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import "./sidebar.css";
import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { FaChevronDown } from "react-icons/fa";

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isFeatureManagementOpen, setIsFeatureManagementOpen] = useState(false);
  const [isCaseManagementOpen, setIsCaseManagementOpen] = useState(false);
  const navigate = useNavigate();

  const toggleBlogManagement = useCallback(() => {
    setIsBlogManagementOpen((prev) => !prev);
  }, []);

  const toggleFeatureManagement = useCallback(() => {
    setIsFeatureManagementOpen((prev) => !prev);
  }, []);

  const toggleCaseManagement = useCallback(() => {
    setIsCaseManagementOpen((prev) => !prev);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("accessToken");
    navigate("/");
  }, [navigate]);

  return (
    <>
      {/* <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>

        <div className="scroller-sidebar">
          <ul>
            <li>Dashboard</li>
            <li onClick={toggleBlogManagement}>
              Blog Management
              <ul
                className={`nested-list ${isBlogManagementOpen ? "open" : "close"
                  }`}
              >
                <li>Author</li>
                <li>Tag</li>
                <li>Category</li>
                <li>
                  <Link to="/admin/blog">Blogs</Link>{" "}
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">
          Logout
        </button>
      </div> */}
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
        <div className="scroller-sidebar">
          <ul
            style={
              isOpen
                ? { transition: "all 0.3s ease-in", opacity: "0" }
                : { transition: "all 0.3s ease-in", opacity: "1" }
            }
          >
            <Link to="/admin">
              <li>Dashboard</li>
            </Link>

            <Link to="/admin/price">
              <li>Pricing</li>
            </Link>

            <Link to="/admin/client-logos">
              <li>Client Logos</li>
            </Link>

            <li onClick={toggleBlogManagement}>
              Blog Management
              <FontAwesomeIcon icon={faSortDown} />
              <ul
                className={`nested-list ${isBlogManagementOpen ? "open" : "close"
                  }`}
              >
                <Link to="/admin/author">
                  <li>Author</li>
                </Link>
                <Link to="/admin/tags">
                  <li>Tag</li>
                </Link>
                <Link to="/admin/category">
                  <li>Category</li>
                </Link>
                <Link to="/admin/blog">
                  <li>Blogs </li>
                </Link>
                <Link to="/admin/ai-blog">
                  <li>AI Blogs </li>
                </Link>
              </ul>
            </li>

            <li onClick={toggleFeatureManagement}>
              Feature Management
              <FontAwesomeIcon icon={faSortDown} />
              <ul
                className={`nested-list ${isFeatureManagementOpen ? "open" : "close"
                  }`}
              >
                <Link to="/admin/feature-pages">
                  <li>Pages</li>
                </Link>

                <Link to="/admin/features">
                  <li>Features</li>
                </Link>

              </ul>
            </li>

            <li onClick={toggleCaseManagement}>
              Case Management
              <FontAwesomeIcon icon={faSortDown} />
              <ul
                className={`nested-list ${isCaseManagementOpen ? "open" : "close"
                  }`}
              >
                <Link to="/admin/case-study">
                  <li>Case Study</li>
                </Link>

                <Link to="/admin/case-category">
                  <li>Case Category</li>
                </Link>

              </ul>
            </li>
            
            <Link to="/admin/media">
              <li>Media Management </li>
            </Link>

            <Link to="/admin/clone-app">
              <li>Clone App Management </li>
            </Link>

            <Link to="/admin/seo">
              <li>SEO Management </li>
            </Link>

            <Link to="/admin/testimonial">
              <li>Video Testimoinals</li>
            </Link>

            {/* <Link to="/admin/emails">
              <li>Dynamic Emails</li>
            </Link> */}

            <Link to="/admin/contact">
              <li>Contact Info</li>
            </Link>

            <Link to="/admin/newsletter">
              <li>Newsletters</li>
            </Link>
          </ul>
        </div>
        <button onClick={handleLogout} className="default-btn logout-button">
          Logout
        </button>
      </div>
    </>
  );
}
